const bindModals = () => {
  const modalTriggers = document.querySelectorAll('.kb-modal-trigger')

  if (modalTriggers.length > 0) {
    modalTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const Modal = document.createElement('kb-modal')
        const content = trigger.querySelector('.kb-modal-content')
        // Store the original parent and position to restore later
        const originalParent = content.parentNode
        const nextSibling = content.nextSibling

        content.style.display = 'block'
        Modal.create('body', content)

        // When modal closes, move the content back to its original position
        Modal.addEventListener('modal-closed', () => {
          if (nextSibling) {
            originalParent.insertBefore(content, nextSibling)
          } else {
            originalParent.appendChild(content)
          }
          content.style.display = ''
        })
      })
    })
  }
}

const initTooltips = () => {
  const tooltipTriggers = document.querySelectorAll('.tooltip__trigger')

  tooltipTriggers.forEach((trigger) => {
    const tooltip = trigger.querySelector('.tooltip__container')
    if (!tooltip) return

    // Add ARIA attributes
    trigger.setAttribute('role', 'button')
    trigger.setAttribute('tabindex', '0')
    trigger.setAttribute(
      'aria-describedby',
      'tooltip-' + Math.random().toString(36).substring(2, 9),
    )
    tooltip.id = trigger.getAttribute('aria-describedby')

    // Handle keyboard interactions
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        trigger.classList.add('tooltip--active')
      }

      if (e.key === 'Escape') {
        trigger.classList.remove('tooltip--active')
      }
    })

    // Handle blur
    trigger.addEventListener('blur', () => {
      trigger.classList.remove('tooltip--active')
    })

    // Handle click for touch devices
    trigger.addEventListener('click', (e) => {
      e.preventDefault()
      trigger.classList.toggle('tooltip--active')
    })
  })
}

if (!customElements.get('kb-modal')) {
  class KBModal extends HTMLElement {
    constructor() {
      super()
      this.addClose = this.addClose.bind(this)
      this.closeMethod = this.closeMethod.bind(this)
    }

    create(parent, content) {
      this.classList.add('kb__modal__container')

      this.parent = document.querySelector(parent)
      const container = document.createElement('div')
      container.classList.add('kb__modal')
      container.append(content)
      this.addClose(container)
      this.content = container
      this.append(container)
      this.parent.prepend(this)

      // Animate it in
      setTimeout(() => {
        this.classList.add('kb__modal__container--active')
      }, 100)

      // Also close when outside is clicked
      this.addEventListener('click', (e) => {
        if (e.target === this) {
          this.closeMethod()
        }
      })

      // Listen for escape keypress
      this.handleEscapeKey = (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          this.closeMethod()
        }
      }
      document.addEventListener('keydown', this.handleEscapeKey)
    }

    addClose(parentNode) {
      const closeButton = document.createElement('div')
      closeButton.classList.add('kb__modal__close')
      closeButton.addEventListener('click', this.closeMethod)
      parentNode.appendChild(closeButton)
    }

    closeMethod() {
      // Allow time for animate-out
      this.classList.remove('kb__modal__container--active')

      setTimeout(() => {
        // Dispatch custom event before removing the modal
        this.dispatchEvent(new CustomEvent('modal-closed'))
        this.remove()
        document.removeEventListener('keydown', this.handleEscapeKey)
      }, 250)
    }

    connectedCallback() {
      // Add any setup you need when the element is added to the DOM
    }

    disconnectedCallback() {
      // Clean up event listeners when the element is removed from the DOM
      document.removeEventListener('keydown', this.handleEscapeKey)
    }
  }
  customElements.define('kb-modal', KBModal)
}

/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
window.Cargo = window.Cargo || {}

if (!Element.prototype.closest) {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector
  }
  Element.prototype.closest = function (s) {
    var el = this
    var ancestor = this
    if (!document.documentElement.contains(el)) return null
    do {
      if (ancestor.matches(s)) return ancestor
      ancestor = ancestor.parentElement
    } while (ancestor !== null)
    return null
  }
}
function initLegacyCargoJS() {
  const menuIcon = document.querySelector('.kb-mobile-nav__menu-toggle')
  const menuPanel = document.querySelector('.kb-mobile-nav__menu')
  const bodyElement = document.querySelector('body')
  const searchBtn = document.querySelector('.kb-header__action--search')
  const closeBtn = document.querySelector('.close-menu')
  const offCanvasSearchMenu = document.querySelector('.off-canvas-search')
  const mainContent = document.querySelector('#main-content')
  const overlay = document.querySelector('.overlay')
  const closeSearch = document.querySelector('.close-search')

  // Legacy code I originally removed, but don't have time to go back through
  // to convert all of these to anchors and style
  function DownloadCargo() {
    window.open('/pages/cargo-download', '_blank')
  }

  document
    .querySelectorAll('.download-cargo-cta')
    .forEach((node) => node.addEventListener('click', DownloadCargo))

  // Check element action add/remove
  let addRemoveOffCanvasClasses = function (
    canvasEle,
    canvasClass,
    elementAction,
  ) {
    if (!canvasEle) return
    if (elementAction === 'add') {
      canvasEle.classList.add(canvasClass)

      // Little hacky, but this whole thing is messy right now.
      // If the user has clicked the search button, we want to focus
      // the search input.
      if (canvasClass === 'show-menu') {
        canvasEle.querySelector('#Search-In-Modal').focus()
      }
    } else {
      canvasEle.classList.remove(canvasClass)

      if (canvasClass === 'show-menu') {
        document.body.classList.remove('kb-menu-open')
      }
    }
  }

  // Add/Remove class to target element
  let addRemoveClassTargetElement = function (
    clickedEle,
    targetEle,
    eleClass,
    eleAction,
  ) {
    if (!clickedEle) return
    clickedEle.addEventListener('click', function () {
      addRemoveOffCanvasClasses(targetEle, eleClass, eleAction)
    })
  }

  // Add click event to target elements to show and hide menu
  let showHideMenus = function (clickedEle, targetEle, elementAction) {
    addRemoveClassTargetElement(
      clickedEle,
      targetEle,
      'show-menu',
      elementAction,
    )
    addRemoveClassTargetElement(
      clickedEle,
      bodyElement,
      'off-canvas-body',
      elementAction,
    )
    addRemoveClassTargetElement(
      clickedEle,
      mainContent,
      'move-content',
      elementAction,
    )
    addRemoveClassTargetElement(
      clickedEle,
      overlay,
      'show-overlay',
      elementAction,
    )
  }

  showHideMenus(menuIcon, menuPanel, 'add')
  showHideMenus(searchBtn, offCanvasSearchMenu, 'add')
  showHideMenus(closeBtn, menuPanel, 'remove')
  showHideMenus(closeSearch, offCanvasSearchMenu, 'remove')
  showHideMenus(overlay, offCanvasSearchMenu, 'remove')
  showHideMenus(overlay, menuPanel, 'remove')

  // New modal logic to watch for trigger elements and clone the modal content
  bindModals()
}

// Stickty Header

function stickyElement(e) {
  var header = document.querySelector('.kb-header')
  var headerContainer = document.getElementById('shopify-section-header')
  var body = document.querySelector('body')
  header.classList.add('sticky__header')
  headerContainer.classList.add('is__sticky')

  var headerHeight = 20 //headerContainer.getBoundingClientRect().height;

  var scrollValue = window.scrollY
  if (scrollValue > headerHeight) {
    body.classList.add('is-sticky')
  } else if (scrollValue < headerHeight) {
    body.classList.remove('is-sticky')
  }
}

window.addEventListener('scroll', stickyElement)

// Lazy Iframe
lazyframe('.lazyframe')

// On Scroll Animation

function showElementAnimation() {
  var element = document.getElementsByClassName('kb-scroll-fadIn-animation')
  if (!element) return

  var showTiming = window.innerHeight > 768 ? 200 : 40
  var scrollY = window.pageYOffset
  var windowH = window.innerHeight

  for (var i = 0; i < element.length; i++) {
    var elemClientRect = element[i].getBoundingClientRect()
    var elemY = scrollY + elemClientRect.top
    if (scrollY + windowH - showTiming > elemY) {
      element[i].classList.add('is-show')
    }
  }
}

showElementAnimation()

window.addEventListener('scroll', showElementAnimation)

/* --------------------------------------------------------------------------------------------------------------
  Logged In Homepage Sliders
-------------------------------------------------------------------------------------------------------------- */
let threeUpSlider, featuredGrid_slider
const breakpointChecker = function (breakpoint) {
  if (breakpoint.matches === true) {
    if (threeUpSlider || featuredGrid_slider) {
      threeUpSlider.forEach((slider) => {
        if (slider) {
          slider.slideTo(1, 0)
          slider.destroy()
        }
      })

      featuredGrid_slider.slideTo(1, 0)
      featuredGrid_slider.destroy()
    }
  } else {
    createSwiper()

    if (!threeUpSlider.destroyed || !featuredGrid_slider.destroyed) {
      if (threeUpSlider.length) {
        threeUpSlider.forEach((slider) => {
          if (slider) {
            slider.updateSlides()
            slider.updateSize()
            slider.slideTo(1, 0)
          }
        })
      }

      if (featuredGrid_slider) {
        featuredGrid_slider.updateSlides()
        featuredGrid_slider.updateSize()
        featuredGrid_slider.slideTo(1, 0)
      }
    }
  }
}

const createSwiper = function () {
  const threeUp = document.querySelector('.threeUp_slider')
  if (threeUp != null) {
    threeUpSlider = new Swiper('.threeUp_slider', {
      slidesPerView: 1.2,
      spaceBetween: 15,
      loop: true,
      direction: 'horizontal',
      breakpoints: {},
    })
  }

  const featureSlider = document.querySelector('.featuredGrid_slider')

  if (featureSlider != null) {
    featuredGrid_slider = new Swiper('.featuredGrid_slider', {
      slidesPerView: 1.2,
      spaceBetween: 15,
      loop: true,
      direction: 'horizontal',
      breakpoints: {},
    })
  }
}

function initThreeUpSlider() {
  const threeUp = document.querySelector('.threeUp_slider')
  const featureSlider = document.querySelector('.featuredGrid_slider')
  if (featureSlider != null || threeUp != null) {
    const breakpoint = window.matchMedia('(min-width:992px)')
    breakpoint.onchange = breakpointChecker
    breakpointChecker(breakpoint)
  }
}

function initKitsCarousel() {
  const myCustomSlider = document.querySelectorAll('.kitsCarousel')

  // Loop through all the carousels and assign a unique id for swiper
  myCustomSlider.forEach((carousel, index) => {
    // Because of how swiper wraps, we need to get the parent element to find
    // the arrows
    const arrows = carousel.parentElement.querySelector('.swiper__arrows')

    // Add a unique class to the carousel
    const uniqueClass = 'kitsCarousel-' + index
    carousel.classList.add(uniqueClass)

    // Initialize the swiper
    var slider = new Swiper(`.${uniqueClass}`, {
      slidesPerView: 2.3,
      spaceBetween: 10,
      loop: true,
      // Only render arrows if they exist
      ...(arrows && {
        navigation: {
          nextEl: arrows.querySelector('.swiper-button-next'),
          prevEl: arrows.querySelector('.swiper-button-prev'),
        },
      }),
      on: {
        init: function () {
          myCustomSlider[index].classList.add('show_kitCarousel')
        },
      },
      breakpoints: {
        767: {
          slidesPerGroup: 1,
          slidesPerView: 4,
          spaceBetween: 10,
        },
        992: {
          slidesPerGroup: 1,
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1920: {
          slidesPerGroup: 1,
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
    })
  })
}

/* ----------------------------------------------------------------
  DROP IN BLOG SPECIFIC
---------------------------------------------------------------- */

const isBlogSingleRoute = window.location.href.includes('/a/blog/')

if (isBlogSingleRoute) {
  const moveSocialSharing = () => {
    const singleBlogContainer = document.querySelector('#dib-post-single')
    const socialSharing = document.querySelector('.dib-sharing')
    singleBlogContainer.appendChild(socialSharing)
  }

  moveSocialSharing()
}

// FAQs
function initFaqs() {
  const questions = document.querySelectorAll('.kbds-faq__item')

  const questionClicked = (question) => {
    // Simply toggle if this one is open
    if (question.classList.contains('active')) {
      question.classList.remove('active')
      return
    }

    // Otherwise strip off all existing opened items
    questions.forEach((question) => {
      question.classList.remove('active')
    })

    // And open just this one
    question.classList.add('active')
  }

  questions.forEach((question) =>
    question
      .querySelector('.kbds-faq__question')
      .addEventListener('click', () => {
        questionClicked(question)
      }),
  )
}

// Global animation helper that simply triggers a class on an element
// when it comes into view.
function simpleAnimationObserver() {
  const standaloneElements = document.querySelectorAll('.kb-animate')

  if (standaloneElements.length === 0) return

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -100px 0px',
    threshold: 0.3,
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('kb-animate--active')
      } else {
        entry.target.classList.remove('kb-animate--active')
      }
    })
  }, observerOptions)

  standaloneElements.forEach((element) => observer.observe(element))
}

function initOrttoForms() {
  /**
   * ORTTO FORM VALIDATION USAGE
   *
   * To enable global validation and thank-you logic for Ortto forms:
   *
   * 1. Add a unique key (e.g. "enterprise-hero") to all related elements:
   *    - <form data-ortto-form-id="KEY">
   *    - <button type="submit" data-ortto-submit="KEY">
   *    - <div data-ortto-hide="KEY">   <!-- wraps the form, hides on submit -->
   *    - <div data-ortto-show="KEY">   <!-- thank-you message, shows on submit -->
   *
   * 2. Use standard HTML5 validation attributes (e.g. required, type="email").
   *
   * 3. Do NOT add custom JS for validation or thank-you logic; the global
   *    initOrttoForms() function will handle it.
   *
   * See examples in template-enterprise.liquid or homepage-email-capture.liquid.
   */

  const orttoForms = document.querySelectorAll('[data-ortto-form-id]')

  orttoForms.forEach(function (form) {
    const key = form.getAttribute('data-ortto-form-id')
    const hideWhenSubmitted = document.querySelector(
      '[data-ortto-hide="' + key + '"]',
    )
    const showWhenSubmitted = document.querySelector(
      '[data-ortto-show="' + key + '"]',
    )

    form.addEventListener('submit', function (e) {
      if (!form.checkValidity()) {
        e.preventDefault()
        form.reportValidity()
      } else {
        // Let Ortto's JS handle the submission!
        if (hideWhenSubmitted) hideWhenSubmitted.style.display = 'none'
        if (showWhenSubmitted) showWhenSubmitted.style.display = 'block'
        // Do NOT call e.preventDefault() or form.submit()
      }
    })
  })
}

// New single DOM Content loaded, move everything to here eventually.
document.addEventListener('DOMContentLoaded', () => {
  // Old, should probably be deprecated/moved to where it's used
  initKitsCarousel()
  initThreeUpSlider()
  initLegacyCargoJS()
  initTooltips()

  // New, actually used globally
  simpleAnimationObserver()
  initFaqs()
  initOrttoForms()
})
